import { useNotification } from './useNotification'
import { ActionError } from '@/common/exceptions'
import { tGlobal } from './useI18n'
import { resolveMiddleUserFacingError } from '@/common/utils/resolveMiddleUserFacingError'

export function useErrorHandler() {
  const notification = useNotification()
  const t = tGlobal

  const handleActionError = (error: ActionError): void => {
    const code = typeof error.code === 'number' ? error.code : parseInt(String(error.code), 10)
    if (code === 2002) {
      return
    }

    if (import.meta.env.DEV) {
      console.error('[ActionError]', {
        code: error.code,
        message: error.message,
        developerMessage: error.developerMessage,
        url: error.url,
        type: error.type,
      })
    }

    const resolution = resolveMiddleUserFacingError({
      code: error.code,
      type: error.type,
      message: error.message,
      developerMessage: error.developerMessage,
    })

    const message =
      resolution.kind === 'unknown'
        ? (error.message?.trim() || t(resolution.i18nKey))
        : t(resolution.i18nKey)

    notification.error({ summary: message })
  }

  return {
    handleActionError,
  }
}

export function handleActionErrorGlobal(error: ActionError): void {
  const { handleActionError } = useErrorHandler()
  handleActionError(error)
}
